import { Shield, Award, MapPin } from "lucide-react";

const features = [
  {
    icon: Award,
    title: "20+ Years Experience",
    description: "Our founder has over two decades of experience in the education sector.",
  },
  {
    icon: Shield,
    title: "Fully Insured",
    description: "Complete peace of mind with comprehensive insurance coverage.",
  },
  {
    icon: MapPin,
    title: "Local Service",
    description: "Serving Rainham and nearby areas within a 15-mile radius.",
  },
];

export function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-muted/30" aria-labelledby="about-heading">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 id="about-heading" className="text-3xl md:text-4xl font-display font-bold text-secondary mb-6">
              Helping You Reach Your Potential
            </h2>
            <p className="text-lg text-muted-foreground mb-6">
              At Upgrade Skills Ltd, we believe everyone deserves the opportunity to improve their employability. 
              Our courses in English, Maths, and employability skills are designed to be practical, 
              accessible, and tailored to your individual goals.
            </p>
            <p className="text-lg text-muted-foreground">
              Based at the CEME Campus in Rainham, we offer a supportive, friendly learning environment 
              where you can develop the skills you need to unlock new career opportunities.
            </p>
          </div>

          <div className="grid gap-6">
            {features.map((feature, index) => (
              <div
                key={feature.title}
                className="flex gap-4 p-6 bg-card rounded-xl shadow-soft border border-border animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                  <feature.icon className="h-6 w-6 text-primary" aria-hidden="true" />
                </div>
                <div>
                  <h3 className="font-display font-bold text-secondary mb-1">{feature.title}</h3>
                  <p className="text-muted-foreground">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}